import reducer from './reducers';

export { default as documentTypesSelectors } from './selectors';
export { default as documentTypesOperations } from './operations';
export { default as documentTypesTypes } from './types';

export default reducer;
